import isEmpty from 'lodash/isEmpty';

import * as utils from '@utils/form';
import { TEXT_POSITIONS } from '@api/constants';
import { IMAGE_SIZE } from '@api/media/constants';
import { TEXT_COLOURS } from '@constants';

export const MODES = {
  EXISTING: { label: 'An existing article', value: 'existing-article' },
  TAG: { label: 'By article tag', value: 'by-tag' },
  MANUAL: { label: 'Manually', value: 'manual' },
  VIDEO: { label: 'YouTube video', value: 'youtube-video' },
};

export const MODE = {
  label: 'Add',
  modes: Object.values(MODES),
};

export const CAROUSEL_FIELDS = {
  SLIDE_POSTED: {
    name: 'posted',
    label: 'posted',
    options: [
      { label: 'This week', value: 'this-week' },
      { label: 'This month', value: 'this-month' },
      { label: 'Last hour', value: 'last-hour' },
    ],
    rules: [{ required: true, message: 'Posted is required' }],
  },
  SLIDE_ARTICLE: {
    name: 'article',
    rules: [{ required: true, message: 'Article is required' }],
  },
  SLIDER_TEXT_POSITION: {
    name: 'textPosition',
    label: 'Text position:',
    positions: TEXT_POSITIONS,
    rules: [{ required: true, message: 'Text position is required' }],
  },
  SLIDE_TEXT_COLOR: {
    name: 'colour',
    label: 'Text Colour:',
    colors: [...TEXT_COLOURS],
    rules: [{ required: true, message: 'Text Colour is required' }],
  },
  SLIDE_LOCATION: {
    name: 'linkUrl',
    label: 'Location:',
    placeholder: 'Enter the URL for the article',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'Url is required' },
    ],
  },
  SLIDE_VIDEO: {
    name: 'videoUrl',
    label: 'Location:',
    placeholder: 'Enter the YouTube URL',
    rules: [
      { type: 'url', message: "Doesn't look like a valid URL" },
      { required: true, message: 'Url is required' },
    ],
  },
  SLIDE_TITLE: {
    name: 'title',
    label: 'Title:',
    placeholder: 'Enter a title for the article',
    rules: [{ required: true, message: 'Title is required' }],
  },
  SLIDE_SUBTITLE: {
    name: 'subtitle',
    label: 'Subtitle:',
    placeholder: 'Enter a title for the article',
    rules: [{ required: true, message: 'Subtitle is required' }],
  },
  SLIDE_STANDFIRST: {
    name: 'standfirst',
    label: 'Standfirst:',
    placeholder: 'Enter a short description for the videoe',
    multiline: true,
    rules: [{ required: true, message: 'Standfirst is required' }],
  },
  SLIDE_IMAGE: {
    name: 'image',
    label: 'Image:',
    rules: [{ required: true, message: 'An image is required' }],
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
};

export const SLIDES = {
  name: 'slides',
  rules: [{ min: 1, max: 6 }],
  serialize: (field, values) => {
    const value = values[field.name];
    return {
      slides: value.map(({ article, ...data }) =>
        article
          ? {
              articleId: article.contentId || article.id,
              imageId: article.featureImageId,
              imageEdited: article.featureImageEdited,
              ...data,
            }
          : { ...data },
      ),
    };
  },
};

export const FORM_SLIDES = {
  SLIDES,
};

export const HERO_CAROUSEL_INITS = {
  slideType: 'existing-article',
  slides: [],
};

export const detectMode = (value) => {
  if (value[CAROUSEL_FIELDS.SLIDE_VIDEO.name]) {
    return MODES.VIDEO;
  }

  if (value[CAROUSEL_FIELDS.SLIDE_ARTICLE.name] || isEmpty(value)) {
    return MODES.EXISTING;
  }

  return MODES.MANUAL;
};
